import React from 'react';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <SEO
        title="Terms & Conditions | Service Agreement | Equi Pulse"
        description="Read the terms and conditions for using Equi Pulse Research advisory services. Understand our service agreement, usage policies, and legal terms."
        url="/terms"
      />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-amber-400 mb-8">Terms and Conditions</h1>
        
        <div className="prose prose-invert prose-amber max-w-none text-gray-300">
          <p className="mb-8">
            By accessing or using the services, website, reports, recommendations, communication channels, or any other content offered by Equi Pulse, you agree to be bound by these Terms & Conditions. These Terms may be updated periodically, and continued usage shall constitute acceptance of updated terms.
          </p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">1. REGISTRATION & ACCESS</h2>
          <p className="mb-4">i. By registering with Equi Pulse, you confirm that all information provided by you is accurate and complete.</p>
          <p className="mb-4">ii. Equi Pulse may suspend or terminate your access without notice if:</p>
          <ul className="list-disc list-inside mb-6 space-y-2 ml-4">
            <li>You engage in unauthorized access or misuse</li>
            <li>You attempt to transfer or assign your rights</li>
            <li>You violate any clause of this Agreement</li>
          </ul>
          <p className="mb-8">iii. By registering, you consent to receive periodic SMS, email alerts, notifications, or newsletters.</p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">2. LICENSE & USAGE RIGHTS</h2>
          <p className="mb-4">i. You receive a personal, limited, non-transferable, non-exclusive license to access Equi Pulse services.</p>
          <p className="mb-8">ii. Usage is strictly for your personal investment analysis and not for commercial distribution.</p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">3. INTELLECTUAL PROPERTY & RESTRICTIONS</h2>
          <p className="mb-4">i. All research reports, trade ideas, content, design, graphics, stock calls, and analysis provided by Equi Pulse are proprietary to Equi Pulse.</p>
          <p className="mb-4">ii. You may not:</p>
          <ul className="list-disc list-inside mb-6 space-y-2 ml-4">
            <li>Reproduce, distribute, publish, broadcast, resell, or make derivative use of any Equi Pulse content</li>
            <li>Share, forward, or post recommendations to any social media, messaging group, forum, or any third party without written permission</li>
            <li>Store or use any content in a machine-readable or search-enabled database</li>
          </ul>
          <p className="mb-8">iii. Any unauthorized sharing will result in immediate termination, and Equi Pulse reserves the right to pursue legal action and damages under applicable Indian law.</p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">4. SERVICE AVAILABILITY & INTERRUPTIONS</h2>
          <p className="mb-4">i. Equi Pulse shall not be liable for interruptions caused by technical failures, downtime, internet issues, maintenance, or events beyond reasonable control (force majeure).</p>
          <p className="mb-8">ii. No guarantees are given for uninterrupted or error-free services.</p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">5. DISCLAIMER & LIMITATION OF LIABILITY</h2>
          <p className="mb-4">i. You acknowledge that all information is provided on an "as is" and "as available" basis without warranty of accuracy, completeness, or suitability.</p>
          <p className="mb-4">ii. Financial markets carry inherent risks. Past performance is not indicative of future results.</p>
          <p className="mb-4">iii. Equi Pulse and its proprietor shall NOT be liable for:</p>
          <ul className="list-disc list-inside mb-6 space-y-2 ml-4">
            <li>Losses of any kind (direct, indirect, financial, emotional, incidental, special, or consequential)</li>
            <li>Trading losses due to market volatility, incorrect interpretation, delay, or non-execution of recommendations</li>
            <li>Any damages arising from use or inability to use the website, services, or information</li>
          </ul>
          <p className="mb-8">iv. All investment decisions are entirely your responsibility. You must consult your own financial, legal, or tax advisor before acting on any recommendation.</p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">6. REFUND & CANCELLATION POLICY</h2>
          <p className="mb-4">i. Equi Pulse follows a strict NO REFUND policy.</p>
          <p className="mb-4">ii. All fees, once paid, are 100% non-refundable, non-transferable, and non-adjustable for any reason whatsoever, including:</p>
          <ul className="list-disc list-inside mb-6 space-y-2 ml-4">
            <li>Perceived service quality</li>
            <li>Market losses</li>
            <li>Change of mind</li>
            <li>Non-usage of the service</li>
            <li>Subscription cancellation before expiry</li>
          </ul>
          <p className="mb-4">iii. No free trial is provided in any form (paid or unpaid).</p>
          <p className="mb-8">iv. Users are expected to read all service details, terms, and disclaimers before making payment.</p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">7. DISPUTE RESOLUTION – ARBITRATION</h2>
          <p className="mb-4">i. All disputes shall be settled through sole arbitration under the Arbitration & Conciliation Act, 1996.</p>
          <p className="mb-4">ii. The sole arbitrator shall be appointed by the Proprietor of Equi Pulse.</p>
          <p className="mb-4">iii. Place & Seat of Arbitration: Indore, Madhya Pradesh, India.</p>
          <p className="mb-8">iv. Indian law shall govern all proceedings.</p>

          <h2 className="text-2xl font-bold text-amber-400 mt-8 mb-4">8. JURISDICTION</h2>
          <p className="mb-8">
            All disputes shall fall under the exclusive jurisdiction of courts in Indore, Madhya Pradesh, India.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;